import type { KeyboardEvent, MouseEvent } from "react";

/** Keeps an open cell editor's clicks and keys away from the grid. */
export const stopPropagation = (event: MouseEvent | KeyboardEvent) =>
    event.stopPropagation();

const isFromEditorOrPicker = (event: KeyboardEvent) =>
    event.target instanceof Node &&
    (event.currentTarget.contains(event.target) ||
        (event.target instanceof Element &&
            event.target.closest("[data-picker-popup]") !== null));

/**
 * Keydown guard for an open cell editor: keeps keys inside the editor, but lets
 * Tab from the editor or its picker popup reach the grid so it commits the pick
 * and moves to the next cell. Tab inside a portalled modal the editor opened
 * (e.g. create counterparty) still bubbles here through React, and stays put.
 */
export const stopPropagationExceptTab = (event: KeyboardEvent) => {
    if (event.key !== "Tab" || !isFromEditorOrPicker(event)) {
        event.stopPropagation();
    }
};
